<template>
    <div>
    <div v-if="passed_filter">
        <div class="designeroption" data-designer-component-id="measurements">
            <h3>Measurements</h3>
            <div class="stylesoption">
                <div :class="['form-group mb-3', !valid_door ? 'has-error' : '']">
                    <label :class="[!valid_door ? 'text-danger' : '']">Door Width x Height</label>
                    <p  class="form-control-static"><span :class="[!valid_door_width ? 'text-danger' : '']">{{ door_width }}mm</span> x <span :class="[!valid_door_height ? 'text-danger' : '']">{{ door_height }}mm</span></p>
                </div>
                <div v-for="measurement in measurements" :class="['form-group mb-3', target[measurement.slug] === undefined || target[measurement.slug] > limits[measurement.slug].max || target[measurement.slug] < limits[measurement.slug].min ? 'has-error' : 'has-success']">
                    <label :for="'measurements' + '_' + measurement.slug">{{ measurement.title }} <template v-if="loading">(Checking Min/Max...)</template><template v-if="!loading">({{ limits[measurement.slug].min }}mm to {{ limits[measurement.slug].max }}mm)</template></label>
                    <input :dusk="measurement.slug" :id="'measurements' + '_' + measurement.slug" type="number" v-model="target[measurement.slug]" class="form-control"
                           :placeholder="measurement.title" min="{{ limits[measurement.slug].min }}" max="{{ limits[measurement.slug].max }}" pattern="[0-9]" @keydown="filterKey" @input="filterInput">
                <span v-if="show_message(measurement.slug, this.frameId)" class="txt-sm">
                    {{ show_message(measurement.slug, this.frameId) }}
                </span>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionMeasurements from "../DesignerQuestionMeasurements.vue";

    export default {
        mixins: [
            DesignerQuestionMeasurements
        ],
        methods: {
            show_message(slug, frame) {
                return ''; // disable messages
                if (slug === 'top_box_drop' || slug === 'right_width' || slug === 'left_width') {
                    return 'Including any add on profiles';
                }
                else if (slug === 'flag_height') {
                    return 'Including any add on or sill profiles';
                }
                else if (slug === 'overall_width') {
                    return 'Including any add on profiles';
                }
                else if (slug === 'overall_height') {
                    return 'Including any add on or sill profiles';
                }
                return false;
            },
        }
    }
</script>
